<template>
  <div>
    <div class="action turn-in-review" @click="$store.commit('showSubmitReviewLink')">Submit Review Link</div>
    <submit-review-link-modal v-if="showSubmitReviewLink" :assignment="assignment"></submit-review-link-modal>
  </div>
</template>

<script>

import { mapState } from "vuex";
import ReviewLinkSubmission from '../ReviewLinkSubmission';

export default {
  name: "TurnInReview",
  props: ["assignment"],
  components: {
    "submit-review-link-modal": ReviewLinkSubmission
  },
  computed: {
    ...mapState({
      showSubmitReviewLink: "showSubmitReviewLink"
    })
  },
  methods: {
    handleClick() {
      this.$store.commit("showSubmitReviewLink");
    }
  }
};
</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
}
.turn-in-review {
  margin: 0;
  margin-top: -6px;
  background: lighten(#c8e6c9, 5%);
  color: #43a047;
  font-size: 10.5pt !important;
}
</style>



